export const useProductSheetBreadcrumb = (props) => {
  const breadcrumbs = computed(() => {
    if (props.breadcrumb.length > 0) {
      const formatedBreadcrumb =
        props.breadcrumb.map((element) => {
          return {
            text: element.title,
            route: element.slug
          }
        });
      return [
        ...formatedBreadcrumb, {
          text: props.product.attributes.designation,
          route: ""
        }]
    } else {
      return props.breadcrumb
    }
  })

  const parentLevel = computed(() => {
    let parentRoute = ""
    if (breadcrumbs.value && breadcrumbs.value.length > 0) {
      const breadcrumbsItemsNumber = breadcrumbs.value.length
      const lastbreadcrumbsItem = breadcrumbs.value[breadcrumbsItemsNumber - 2]
      parentRoute = lastbreadcrumbsItem.route
    }
    return parentRoute
  })

  const getBreadCrumbByPosition = (pos) => {
    if (breadcrumbs.value && breadcrumbs.value.length > 0) {
      return breadcrumbs.value[pos - 1]
    }
  }

  return {
    breadcrumbs,
    parentLevel,
    getBreadCrumbByPosition
  }
}
